import styled, { createGlobalStyle } from 'styled-components';
import { media } from '../../utils';

export const Banner = styled.div<{ bgphoto?: string }>`
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 0px 0px 0px; /* top right bottom left */
  margin-bottom: 40px;
  background-image: url(${(props) => props.bgphoto}; //(Optional) Fallback bgImg
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${media('mobile')} {
    padding: 20px;
  }

  /* Swiper Container */
  .swiper-container {
    width: 100%;
    height: 100%;
    margin: 0px 0px 0px 0px //explicit justincase
  }

  /* Swiper Slide */
  .swiper-slide {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%
    height: 100% /*Fill the .swiper-container*/
    background-size: cover;
    background-position: center;
    position: relative;
  }

  .slide {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
  }

  /* Navigation Buttons */
  .swiper-button-prev,
  .swiper-button-next {
    color: white;
    width: 64px;
    height: 64px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }

  .swiper-button-prev:hover,
  .swiper-button-next:hover {
    background-color: rgba(0, 0, 0, 0.8);
  }

  /* Position Navigation Buttons */
  .swiper-button-prev {
    left: 5%;
  }
  .swiper-button-next {
    right: 5%;
  }

  //Nav Arrow Styling
  .swiper-button-prev::after,
  .swiper-button-next::after {
    font-size: 32px; //arrow icon size
    font-weight: 1500; //bold: 900
    line-height: 1; /* ensure it doesn't push the container too large */
`;

//Global Style(Will affect Whole App) to override Swiper default styles
export const GlobalStyle = createGlobalStyle`
  /* Pagination Dots */
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.5);
    opacity: 1;
  }

  .swiper-pagination-bullet-active {
    background: #fff;
  }
`;

export const Wrapper = styled.div`
  position: absolute;
  bottom: 35%;
  width: 40%;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  right: 45%;
  user-select: none;

  ${media('mobile')} {
    width: 70%;
  }
`;

export const Title = styled.h2`
  font-size: 3.2vw;
  font-weight: bold;
  margin-bottom: 30px;

  &::selection {
    background-color: transparent;
  }

  ${media('mobile')} {
    font-size: 26px;
  }
`;

export const Overview = styled.p`
  font-size: 1.2vw;
  margin-bottom: 40px;
  letter-spacing: .8px;
  line-height: 1.5;
  /* _line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: default;

  &::selection {
    background-color: transparent;
  }

  ${media('mobile')} {
    font-size: 12px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const BannerButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 2.7em;
  padding: 0 50px;
  border-radius: 5px;
  border: none;
  margin-right: 20px;
  background-color: rgba(0, 0, 0, 0.7);
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  transition: box-shadow 200ms ease-in-out, background-color 0.3s ease, color 0.3s ease;;
  cursor: pointer;

  :last-child {
    margin-right: 0;
  }

  :hover {
    background-color:rgba(231, 231, 231, 0.9);
    color: #000000;
    //box-shadow: 0 10px 20px 0 #000000;
  }

  ${media('tablet')} {
    font-size: 14px;
    padding: 0 20px;
  }

  ${media('mobile')} {
    gap: 10px;
  }
`;
